import { HttpInterceptors } from "./http.interceptor";

export class FuncionalityService extends HttpInterceptors {
	async listFuncionalities () {
		const response = await this.axios.get("funcionalities/listFuncionalities");
		return response.data;
	}
}
